/** @jsxImportSource @emotion/react */

const RightIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48"><path d="M530-481 332-679l43-43 241 241-241 241-43-43 198-198Z"/></svg>
  )
}

export default RightIcon
